import { toast } from 'react-toastify';
import { DateTime } from 'luxon';

const Utils = {
    mobileCheck: function() {
        let check = false;
        (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
        return check;
    },
    toBase64: (buffer) => {
        return btoa(
            new Uint8Array(buffer).reduce(
              (data, byte) => data + String.fromCharCode(byte),
              ''
            )
        )
    },
    getUniqueDevideId: function () {
        var navigator_info = window.navigator;
        var screen_info = window.screen;
        var uid = navigator_info.mimeTypes.length;
        uid += navigator_info.userAgent.replace(/\D+/g, '');
        uid += navigator_info.plugins.length;
        uid += screen_info.height || '';
        uid += screen_info.width || '';
        uid += screen_info.pixelDepth || '';
        return uid;
    },  
    makeid: (length) => {
        let result = '';
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        const charactersLength = characters.length;
      
        for (let i = 0; i < length; i++) {
          result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
    },
    stringToSlug: (str) => {
        // Remove caracteres especiais e converte para letras minúsculas
        str = str.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
        // Substitui espaços por hífens
        str = str.replace(/\s+/g, '-');
        // Remove caracteres especiais que não foram removidos na primeira etapa
        str = str.replace(/[^\w\-]+/g, '');
        return str;
    },
    calculateDistance: function (lat1, lon1, lat2, lon2) {
        const R = 6371; // Raio da Terra em km
        const dLat = (lat2 - lat1) * Math.PI / 180;
        const dLon = (lon2 - lon1) * Math.PI / 180;
        const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        const d = R * c; // Distância em km
        return d;
    },
    convertToBase64: function (buffer) {
        if(buffer == undefined) return null;
        return 'data:image/jpeg;base64,'+btoa(
            new Uint8Array(buffer.data).reduce(
              (data, byte) => data + String.fromCharCode(byte),
              ''
            )
        )
    },
    notify: (type, message) => {
        switch(type) {
            case "success":
                toast.success(message, {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                })
                break;
            case "error":
                toast.error(message, {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                  })
                break;
        }
    },
    validatePhoneNumber: (phoneNumber) => {
        var regex = /^\(\d{2}\) \d{5}-\d{4}$/;
        return regex.test(phoneNumber);
    },
    checkPasswordStrength: (password) => {
        // Verifica se a senha contém letras e números
        var containsLettersAndNumbers = /[a-zA-Z]/.test(password) && /\d/.test(password);
        
        // Verifica se a senha contém símbolos, opcionalmente
        var containsSymbols = /[\W_]/.test(password);
      
        // Verifica se a senha é forte o suficiente
        if (containsLettersAndNumbers && (containsSymbols || password.length >= 6)) {
          return true;
        } else {
          return false;
        }
    },  
    processRequest: (request, onSuccess, onFailure, showSuccessMessage) => {
        try{
            if(showSuccessMessage){
                if(request?.data?.success){
                    Utils.notify("success", request?.data?.message);
                    if(onSuccess){
                        onSuccess(request?.data?.data);
                    }
                }
            }
            if(!request?.data?.success){
                Utils.notify("error", request?.response?.data?.message);
                if(onFailure){
                    onFailure(request?.response?.data);
                }
                return;
            }else{
                Utils.notify("success", request?.response?.data?.message);
                if(onSuccess){
                    onSuccess(request?.data?.data);
                }
                return;
            }
        }catch(err){
            Utils.notify("error", err);
            onFailure(err);
            return;
        }
    },
    converterDate: (dataString) => {
        // Criar um DateTime a partir da string de data e ajustar para o fuso horário de São Paulo
        const data = DateTime.fromISO(dataString, { zone: 'America/Sao_Paulo' }).plus({ hours: 3 });
  
    
        // Extrair os componentes da data
        const dia = data.day.toString().padStart(2, '0');
        const mes = data.month.toString().padStart(2, '0');
        const ano = data.year;
        const hora = data.hour.toString().padStart(2, '0');
        const minutos = data.minute.toString().padStart(2, '0');
    
        // Retornar a data formatada
        return `${dia}/${mes}/${ano} ${hora}:${minutos}`;
    },
    converterDateAndRemoveHours: (dataString) => {
        // Criar um DateTime a partir da string de data e ajustar para o fuso horário de São Paulo
        const data = DateTime.fromISO(dataString, { zone: 'America/Sao_Paulo' }).plus({ hours: 3 });

        // Extrair os componentes da data
        const dia = data.day.toString().padStart(2, '0');
        const mes = data.month.toString().padStart(2, '0');
        const ano = data.year;
    
        // Retornar a data formatada
        return `${dia}/${mes}/${ano}`;
    },
    converterDateUS: (dataString) => {
        let parts = dataString?.split('/');
        return `${parts[2] || new Date().getFullYear()}-${parts[1] || (new Date().getMonth()+1).toString().padStart(2, '0')}-${parts[0] || ""}`;
    },
    validateEmail: (email) => {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email);
    },
    validateCpf: (cpf) => {
        if(!cpf) return false;
        cpf = cpf.replace(/[^\d]/g, ''); // Remove caracteres não numéricos
        if (cpf.length !== 11) return false;

        // Verifica se todos os dígitos são iguais, o que não é válido para um CPF
        if (/^(\d)\1+$/.test(cpf)) return false;

        // Algoritmo de validação do CPF
        let sum = 0;
        let remainder;

        for (let i = 1; i <= 9; i++) {
            sum += parseInt(cpf.substring(i - 1, i)) * (11 - i);
        }
        remainder = (sum * 10) % 11;

        if ((remainder === 10) || (remainder === 11)) {
            remainder = 0;
        }

        if (remainder !== parseInt(cpf.substring(9, 10))) {
            return false;
        }

        sum = 0;
        for (let i = 1; i <= 10; i++) {
            sum += parseInt(cpf.substring(i - 1, i)) * (12 - i);
        }
        remainder = (sum * 10) % 11;

        if ((remainder === 10) || (remainder === 11)) {
            remainder = 0;
        }

        if (remainder !== parseInt(cpf.substring(10, 11))) {
            return false;
        }

        return true;
    },
    checkMinutesDate(dataText, verification) {
        // Converter a dataText para um objeto Date
        const dataReferencia = new Date(dataText);

        // Obter a data e hora atual
        const dataAtual = new Date();

        // Adicionar 30 minutos à data de referência
        dataReferencia.setMinutes(dataReferencia.getMinutes() + verification);

        // Verificar se a data atual é maior que a data de referência
        return dataAtual > dataReferencia;
    },
    verifyPastDate: (dataString) => {
        // Obtém a data atual, sem horas, minutos, segundos e milissegundos
        var dataAtual = new Date();
        dataAtual.setHours(0, 0, 0, 0);
    
        // Converte a string de data para um objeto Date, sem horas, minutos, segundos e milissegundos
        var partesData = dataString.split('/');
        var data = new Date(partesData[2], partesData[1] - 1, partesData[0]);
        data.setHours(0, 0, 0, 0);
    
        // Verifica se a data fornecida é anterior à data atual
        if (data < dataAtual) {
            return true; // A data fornecida já passou
        } else if (data.getTime() === dataAtual.getTime()) {
            return false; // A data fornecida é igual à data atual
        } else {
            return false; // A data fornecida está no futuro
        }
    },
    checkWeekDayAndReturnExpediente: (day, data) => {
        const diasDaSemana = ["domingo", "segunda", "terca", "quarta", "quinta", "sexta", "sabado"];
        const diasDaSemanaAbreviados = ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"];

        const index = diasDaSemanaAbreviados.indexOf(day?.diaSemana);
        const diaAtual = diasDaSemana[index];

        if (data[diaAtual] === 0) {
            return { inicio: null, fim: null };
        }

        const horario = {
            abertura: Number(data[diaAtual + "_hora_inicio"]),
            fechamento: Number(data[diaAtual + "_hora_fim"])
        };

        return horario;
    },
    dataEhAtual: (data) => {
        // Obter a data atual
        var dataAtual = new Date();
        
        // Separar a data atual em dia, mês e ano
        var diaAtual = dataAtual.getDate();
        var mesAtual = dataAtual.getMonth() + 1; // Os meses em JavaScript começam de 0
        var anoAtual = dataAtual.getFullYear();
      
        // Separar a data fornecida em dia, mês e ano
        var partes = data.split('/');
        var dia = parseInt(partes[0]);
        var mes = parseInt(partes[1]);
        var ano = parseInt(partes[2]);
      
        // Verificar se as datas são iguais
        return dia === diaAtual && mes === mesAtual && ano === anoAtual;
    },
    converterMoedaParaNumero: (valorString) => {
        // Remove o símbolo de moeda "R$" e quaisquer espaços em branco
        const valorLimpo = valorString.replace(/[^\d,-]/g, '');
    
        // Converte a string para um número
        const valorNumero = parseFloat(valorLimpo.replace(',', '.'));
    
        return valorNumero;
    },
    calcularAvaliacao: (avalicoes) => {
        try{
            // Verifica se há avaliações
            if (avalicoes?.length === 0) {
                return 0;
            }
            
            // Soma todas as avaliações
            const somaAvaliacoes = avalicoes.reduce((total, avaliacao) => total + avaliacao, 0);
            
            // Calcula a média das avaliações
            const mediaAvaliacoes = somaAvaliacoes / avalicoes.length;
            
            return mediaAvaliacoes.toFixed(1).toString().replace(".", ",");
        }catch(err){
            return Number(0).toFixed(1).toString().replace(".", ",");
        }
    },
    formatarParaCelular: (numero) => {
        if(!numero) return;
        // Remove caracteres não numéricos
        const numeros = numero.replace(/\D/g, '');
        // Aplica a formatação
        const regex = /^(\d{2})(\d{5})(\d{4})$/;
        const celularFormatado = numeros.replace(regex, '($1) $2-$3');
        return celularFormatado;
    },
    convertImageBufferURI: (imagem) => {
        if(!imagem) return null;
        let base64 = Utils.convertToBase64(imagem);
        function base64toBlob(base64) {
            const [data, mimeType] = base64.split(',');
            const binary = window.atob(data);
            const arrayBuffer = new ArrayBuffer(binary.length);
            const uint8Array = new Uint8Array(arrayBuffer);
            for (let i = 0; i < binary.length; i++) {
                uint8Array[i] = binary.charCodeAt(i);
            }
            return new Blob([arrayBuffer], { type: mimeType });
        }
        const base64WithoutHeader = base64.replace(/^data:image\/\w+;base64,/, '');
        return base64toBlob(base64WithoutHeader);
    },
    fetchImage: async (uri) => {
        try {
            const response = await fetch(uri);
            const blob = await response.blob(); // Obtém o blob da imagem
            return blob;
        } catch (error) {
            console.error(error);
        }
    },
    isImageValid: (file) => {
        const allowedTypes = ['image/png', 'image/jpeg', 'image/jpg'];
        if (!allowedTypes.includes(file.type)) {
            Utils.notify("error", "O arquivo deve ser uma imagem PNG, JPEG ou JPG.");
            return false;
        }
    
        // Verificar se o tamanho é menor que 5MB
        const maxSize = 10 * 1024 * 1024; // 5MB em bytes
        if (file.size > maxSize) {
            Utils.notify("error", "O tamanho da imagem deve ser menor que 10MB.");
            return false;
        }
    
        return true;
    },
    getDeviceToken: () => {
        return localStorage.getItem("tk_beauty_device_token") ? localStorage.getItem("tk_beauty_device_token") : null;
    },
    isEmpty: (str) => {
        if(str == undefined) return true;
        if(str === null) return true;
        return str.trim()?.length <= 0
    },
    validateCep: (cep) => {
        const cepRegex = /^[0-9]{5}-[0-9]{3}$/;
        return cepRegex.test(cep);
    },
    validateCNPJ: (cnpj) => {
        cnpj = cnpj.replace(/[^\d]+/g, '');
    
        if (cnpj.length !== 14) {
            return false;
        }
    
        // Elimina CNPJs inválidos conhecidos
        if (/^(\d)\1*$/.test(cnpj)) {
            return false;
        }
    
        // Valida DVs
        let tamanho = cnpj.length - 2;
        let numeros = cnpj.substring(0, tamanho);
        let digitos = cnpj.substring(tamanho);
        let soma = 0;
        let pos = tamanho - 7;
    
        for (let i = tamanho; i >= 1; i--) {
            soma += numeros.charAt(tamanho - i) * pos--;
            if (pos < 2) pos = 9;
        }
        let resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
    
        if (resultado !== parseInt(digitos.charAt(0))) {
            return false;
        }
    
        tamanho = tamanho + 1;
        numeros = cnpj.substring(0, tamanho);
        soma = 0;
        pos = tamanho - 7;
    
        for (let i = tamanho; i >= 1; i--) {
            soma += numeros.charAt(tamanho - i) * pos--;
            if (pos < 2) pos = 9;
        }
        resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
    
        if (resultado !== parseInt(digitos.charAt(1))) {
            return false;
        }
    
        return true;
    },
    verificarUrlParceiro: (url) => {
        try {
            const parsedUrl = new URL(url);
    
            // Verifique o hostname
            if (parsedUrl.hostname !== 'app.igend.com.br' && parsedUrl.hostname !== "localhost") {
                Utils.notify("error",'Hostname inválido');
                return;
            }
    
            // Verifique o pathname
            const pathname = parsedUrl.pathname.split('/');
            if (pathname[1] !== 'parceiro') {
                Utils.notify("error", 'Rota inválida');
                return;
            }
    
            // Extraia a chave
            const chave = pathname[2];
    
            // Verifica se a chave existe e não está vazia
            if (!chave) {
                Utils.notify("error", 'Chave inválida');
                return;
            }
    
            return chave;
        } catch (error) {
            console.error(error.message);
            return null;
        }
    },
    converterHoraPorExtenso: (hora) => {
        try{
            var partes = hora.split('h');
            var horas = parseInt(partes[0]);
            var minutos = parseInt(partes[1].replace('m', ''));
        
            if (minutos == 29) {
                minutos = 30;
            }
            
            if(minutos == 0) {
                return horas + 'h';
            }else{
                return horas + 'h e ' + minutos + 'm';
            }
        }catch(err){
            var partes = hora.split('m');
            var minutos = parseInt(partes[0]);
            if (minutos == 29) {
                minutos = 30;
            }
            return minutos + 'm';
        }
    },
    parceiroCategorryMapper: (categoryId) => {
        switch(categoryId){
            case 16: //id_categoria caso seja studio musical
                return {
                    PARCEIRO_AGENDA_SELECT_LABEL_NAME: "Polo",
                    PARCEIRO_AGENDA_BOTTOM_MENUNAME_EQUIPE: "Polos"
                }
            default: 
                return {
                    PARCEIRO_AGENDA_SELECT_LABEL_NAME: "Profissional",
                    PARCEIRO_AGENDA_BOTTOM_MENUNAME_EQUIPE: "Equipe",
                }
        }
    },
    isWebView: () => {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;

        // Verifique se o usuário está em um computador
        const isDesktop = !(/Android|iPhone|iPad|iPod/i.test(userAgent));

        if (isDesktop) {
            return false;
        }
      
        const isAndroidWebView = /\bwv\b/.test(userAgent) || /Android.*Version\/[\d.]+.*\bwv\b/.test(userAgent);
      
        const isIOSWebView = (function() {
          const iOS = /iP(ad|hone|od)/.test(userAgent);
          if (iOS) {
            if (/(CriOS|FxiOS|OPiOS|EdgiOS)/.test(userAgent)) {
              return false;
            }
            return !/Safari/.test(userAgent);
          }
          return false;
        })();
      
        return isAndroidWebView || isIOSWebView;
    },
    validarPontoEntrega: (pontosEntrega, uf, id_municipio) => {
        return pontosEntrega.some(ponto => ponto.uf == uf && ponto.id == id_municipio);
    },
    obterValorMunicipio: (pontosEntrega, uf, id_municipio) => {
        const municipio = pontosEntrega.find(ponto => ponto.uf === uf && ponto.id === id_municipio);
        if(municipio){
            const valorLimpo = (municipio?.valor?.replace(/[^\d,-]/g, '') || 0);
            const valorNumero = parseFloat(valorLimpo.replace(',', '.'));
            return municipio ? valorNumero : 0;
        }else{
            return 0;
        }
    },
    detectarDispositivo: () => {
        const userAgent = navigator.userAgent;
        if (/Android/i.test(userAgent)) {
            return 'Android';
        } else if (/iPhone|iPad|iPod/i.test(userAgent)) {
            return 'iPhone';
        } else {
            return 'other';
        }
    },
    converterDateBR: (str) => {
        let split_date_with_hours = str.split(" ");
        let date_splites = split_date_with_hours[0];
        let date_parts = date_splites.split('-');
        return `${date_parts[2]}/${date_parts[1]}/${date_parts[0]}`;
    }
}

export default Utils;